import {
  CardContent,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Grid,
  List,
  ListItemIcon,
  ListItemText,
  CircularProgress,
  LinearProgress,
  Tooltip
} from "@mui/material";
import Icon from "../../../components/icon";
import { styled } from '@mui/material/styles';
import { Fragment, useEffect, useState } from 'react';
import MuiCard from '@mui/material/Card';
import ListItem from '@mui/material/ListItem'
import IconButton from '@mui/material/IconButton'
// import ExcelCSVImport from "../../../components/ExcelCSVImport";
import CloseIcon from '@mui/icons-material/Close';
import Papa from 'papaparse'
import * as XLSX from 'xlsx'
import { ToastContainer, toast } from 'react-toastify';

import { useDropzone } from 'react-dropzone'

const renderFilePreview = (file) => {
  let icon;

  if (file.name.includes('.xlsx')) {
    icon = "../../images/xlsx.png";
  } else if (file.name.includes('.csv')) {
    icon = "../../images/csv.png";
  } else if (file.type.includes('image')) {
    icon = "../../images/image_placeholder.png"; // Placeholder for images
  } else if (file.name.includes('jpg')) {
    icon = "../../images/image_placeholder.png"; // Placeholder for images
  } else if (file.name.includes('jpeg')) {
    icon = "../../images/image_placeholder.png"; // Placeholder for images
  } else if (file.name.includes('png')) {
    icon = "../../images/image_placeholder.png"; // Placeholder for images
  } else if (file.name.includes('.pdf')) {
    icon = "../../images/pdf_placeholder.png"; // Placeholder for PDFs
  } else {
    icon = "../../images/placeholder.png"; // Optional: a default placeholder for unsupported types
  }

  return <img src={icon} width="40" height="40" alt="file preview" />;
};


const Card = styled(MuiCard)(({ theme }) => ({
  [theme.breakpoints.up('sm')]: { width: '100%' }
}));

const JobsiteAttachment = ({
  open,
  setOpen,
  handleClose,
  Title,
  files,
  setFiles,
  customer,
  sf
}) => {

  const [message, setMessage] = useState('');
  const [btnLoader, setBtnLoader] = useState(false);
  
  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => {
        setMessage('');
      }, 10000);
      return () => clearTimeout(timer);
    }
  }, [message]);

  const handleUpload = () => {
    sf((prevFiles) => [...prevFiles, ...files]);
    setFiles([]);
    setOpen(false);
  }

  const { getRootProps, getInputProps } = useDropzone({
    maxFiles: 4,
    maxSize: 2000000, // 2 MB in bytes
    accept: {
      'text/csv': ['.csv'],
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
      'application/pdf': ['.pdf'],
      'image/jpeg': ['.jpg', '.jpeg'],
      'image/png': ['.png'],
   },
    onDrop: acceptedFiles => {
      setBtnLoader(true);  
      setTimeout(() => {
        setFiles(acceptedFiles.map(file => Object.assign(file)));
        setBtnLoader(false); 
      }, 1000);  // Simulating a delay for loading effect
    },
    onDropRejected: () => {
      //toast.error('You can only upload 1 file with a maximum size of 2 MB.', {
      //  duration: 2000
      //});
      // setMessage('You can only upload 1 file with a maximum size of 2 MB.');
      setBtnLoader(false);
    }
  });

  // const fileList = files.map(file => (
  //     <ListItem key={file.name} sx={{display:'flex', justifyContent:'center !important',marginTop:'5px',width: 'fit-content', boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px', borderRadius:'10px'}}>
  //       <Box className='file-details' sx={{display:'flex'}} >
  //         <Box className='file-preview' sx={{display:'flex', alignItems:'center', textAlign:'center'}}>{renderFilePreview(file)}
  //             <Box sx={{display:'flex', flexDirection:'column'}}>
  //                 <Typography className='file-name'>{file.name}</Typography>    
  //                 <Typography className='file-size' variant='body2'>
  //                     {Math.round(file.size / 100) / 10 > 1000
  //                     ? `${(Math.round(file.size / 100) / 10000).toFixed(1)} mb`
  //                     : `${(Math.round(file.size / 100) / 10).toFixed(1)} kb`}
  //                 </Typography> 
  //             </Box>                     
  //         </Box>            
  //       </Box>
  //       <IconButton onClick={() => handleRemoveFile(file)}>
  //         <Icon icon='tabler:x' fontSize={20} />
  //       </IconButton>
  //     </ListItem>
  //   ));

  const fileList = files.map(file => (
    <ListItem key={file.name} sx={{p:0}}>
      <Card sx={{ padding: '10px !important' }}>
        <CardContent sx={{ padding: '0px !important' }}>
          <Box sx={{display: 'flex', gap: 2}}>
            <Box>{renderFilePreview(file)}</Box>
            <Box sx={{display: 'flex', flexDirection: 'column', width: '100%', gap: 2}}>
              <Box sx={{display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between'}}>
                <Box>
                  <Typography className='file-name'>{file.name}</Typography>
                  <Typography className='file-size' variant='body2'>
                    {Math.round(file.size / 100) / 10 > 1000
                    ? `${(Math.round(file.size / 100) / 10000).toFixed(1)} mb`
                    : `${(Math.round(file.size / 100) / 10).toFixed(1)} kb`}
                  </Typography> 
                </Box>
                <Tooltip title='Remove File'>
                  <IconButton onClick={() => handleRemoveFile(file)}>
                    <Icon icon='tabler:x' fontSize={20} />
                  </IconButton>
                </Tooltip>
              </Box>
              <Box sx={{display: 'flex', alignItems: 'center', gap: 4}}>
                <Box sx={{width: '100%'}}>
                  <LinearProgress value={100} variant="determinate"
                    sx={{
                      '& .MuiLinearProgress-bar': {
                        backgroundColor: 'success.main'
                      },
                      height: '10px'
                    }}
                  />
                </Box>
                <Box color="success.main">
                  <Icon icon="tabler:circle-check-filled" />
                </Box>
              </Box>
            </Box>
          </Box>
        </CardContent>
      </Card>
    </ListItem>
));

  const handleRemoveFile = (file) => {
      const filteredFiles = files?.filter(i => i.name !== file.name);
      setFiles(filteredFiles);
  };
  

  return (
      <Dialog
          fullWidth={true}
          maxWidth="sm"
          open={open}
          onClose={handleClose}
          aria-labelledby="form-dialog-title"
          PaperProps={{
              sx: {
                  maxHeight: '90vh',
                  overflow:'hidden',
              },
          }}
      >
          <DialogTitle sx={{borderBottom: '1px solid #D9D9D9', paddingBottom: '20px !important'}}>
              <Box
                  sx={{
                  display: 'flex',
                  alignItem: 'center',
                  justifyContent: 'space-between',
                  }}
              >
                  <Typography variant="h3" fontWeight='bold'>{Title}</Typography>
                  <IconButton onClick={handleClose}>
                  <Icon icon='tabler:x' />
                  </IconButton>
              </Box>
          </DialogTitle>
          {/* <DialogContent sx={{ display: "flex" }}>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', maxWidth: '100%', flexDirection: 'column'  , height:'fit-content', padding:'20px' }}>
                  <Grid container spacing={5}>                      
                      <Grid item xs={12}>
                          {message && (
                            <Box mb={2} textAlign="center">
                              <Typography variant="h6" color={message.includes('successfully') ? 'green' : 'red'}>
                                {message.split('\n').map((line, index) => (
                                  <div key={index}>{line}</div>
                                ))}
                              </Typography>
                            </Box>
                          )}
                          <Box sx={{ mb: 4, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>                                
                              { customer && (
                                <Typography sx={{ color: 'text.secondary' }}>Upload Attachment For {customer?.firstName} {customer?.lastName} </Typography>
                                
                              )}
                          </Box>
                      </Grid>
                      <Grid item xs={12} sx={{ mb: 4 }}>
                          <Card sx={{ cursor: 'pointer' }}>
                              <CardContent sx={{ p: 10, flexGrow: 1, width: '100%' }}>
                                  <Fragment>
                                      <div {...getRootProps({ className: 'dropzone' })}>
                                          <input {...getInputProps()} />
                                          <Box sx={{ display: 'flex', textAlign: 'center', alignItems: 'center', flexDirection: 'column' }}>
                                              <Box
                                                  sx={{
                                                      mb: 8.75,
                                                      width: 48,
                                                      height: 48,
                                                      display: 'flex',
                                                      borderRadius: 1,
                                                      alignItems: 'center',
                                                      justifyContent: 'center',
                                                      backgroundColor: theme => `rgba(${theme.palette.customColors.main}, 0.08)`
                                                  }}
                                              >
                                                  <Icon icon='tabler:upload' fontSize='1.75rem' />
                                              </Box>
                                              <Typography variant='h4' sx={{ mb: 2 , fontSize:'1.2rem'}}>
                                                  Choose a file or drag & drop it here.
                                              </Typography>
                                              <Typography sx={{ color: 'text.secondary', fontSize:'0.8rem' }}>Only CSV, XLSX, Images, and PDFs, up to 2 MB.</Typography>
                                          </Box>
                                      </div>
                                      {files.length ? (
                                      <Fragment>
                                          <List sx={{display:'flex', justifyContent:'center !important'}}>{fileList}</List>
                                      </Fragment>
                                      ) : null}
                                  </Fragment>
                              </CardContent>
                          </Card>
                      </Grid>                        
                  </Grid>
              </Box>
          </DialogContent> */}
          <DialogContent>
                <Grid container spacing={5} my={4}>
                    <Grid item xs={12}>
                        {message && (
                        <Box mb={2} textAlign="center">
                            <Typography variant="h6" color={message.includes('successfully') ? 'green' : 'red'}>
                            {message.split('\n').map((line, index) => (
                                <div key={index}>{line}</div>
                            ))}
                            </Typography>
                        </Box>
                        )}
                        <Box sx={{ textAlign: 'center' }}>                                
                            <Typography variant='h5'>Upload Attachment For {customer?.firstName} {customer?.lastName}</Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={12}>
                        <Card sx={{ cursor: 'pointer' }}>
                            <CardContent>
                                    <div {...getRootProps({ className: 'dropzone' })}>
                                        <input {...getInputProps()} />
                                        <Box sx={{ display: 'flex', textAlign: 'center', alignItems: 'center', flexDirection: 'column' }}>
                                            <Box
                                                sx={{
                                                    mb: 6,
                                                    width: 48,
                                                    height: 48,
                                                    display: 'flex',
                                                    borderRadius: 1,
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    backgroundColor: theme => `rgba(${theme.palette.customColors.main}, 0.08)`
                                                }}
                                            >
                                                <Icon icon='tabler:upload' fontSize='1.75rem' />
                                            </Box>
                                            <Typography variant='h4' sx={{ mb: 2 , fontSize:'1.2rem'}}>
                                                Click to Browse or Drag & Drop files here
                                            </Typography>
                                            <List>
                                            <ListItem disablePadding>
                                                <ListItemIcon>
                                                <Icon icon='tabler:circle-filled' height={7} width={7} />
                                                </ListItemIcon>
                                                <ListItemText>
                                                Accepted formats: CSV, XLSX, PDF, DOC, JPEG, PNG, MP4
                                                </ListItemText>
                                            </ListItem>
                                            <ListItem disablePadding>
                                                <ListItemIcon>
                                                <Icon icon='tabler:circle-filled' height={7} width={7} />
                                                </ListItemIcon>
                                                <ListItemText>
                                                Size limit: Video 100MB, Image 6MB, other files 2MB
                                                </ListItemText>
                                            </ListItem>
                                            <ListItem disablePadding>
                                                <ListItemIcon>
                                                <Icon icon='tabler:circle-filled' height={7} width={7} />
                                                </ListItemIcon>
                                                <ListItemText>
                                                Only one (1) file can be uploaded at once
                                                </ListItemText>
                                            </ListItem>
                                            </List>
                                        </Box>
                                    </div>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12}>
                    {files.length ? (
                        <Fragment>
                            <List>{fileList}</List>
                        </Fragment>
                    ) : null}
                    </Grid>                  
                </Grid>
          </DialogContent>
          {/* <DialogActions sx={{ display: "flex", justifyContent: "space-between" , padding: '0.25rem 1.625rem 0.625rem !important'}} className="dialog-actions-dense">               
              <Box>
                  <Button variant='outlined' onClick={handleClose}>
                      Cancel
                  </Button>
              </Box>
               <Box>
                  <Button
                      variant='contained'
                      color='main'
                      disabled={btnLoader}
                      onClick={() => handleUpload()}
                  >
                      {btnLoader ? <CircularProgress size={24} /> : 'Upload'}
                  </Button>
              </Box>
          </DialogActions> */}
          <DialogActions
          sx={{ 
                display: "flex", 
                justifyContent: "space-between", 
                padding: '20px 24px !important', 
                boxShadow: `0px -4px 8px rgb(0, 0, 0, 0.1)`, 
                zIndex: 1 
            }}
          className="dialog-actions-dense"
        >
          <Box>
            <Button
              variant="contained"
              color="info"
              onClick={handleClose}
            >
              Cancel
            </Button>
          </Box>
          <Box>
            <Button
                variant='contained'
                color='main'
                disabled={btnLoader}
                onClick={handleUpload}
            >
                {btnLoader ? <CircularProgress size={24} /> : 'Upload'}
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
  );
};

export default JobsiteAttachment;
